<template>
    <main-layout>
        <template #header>
            <main-header :title="'임대업체 권한 그룹 편집'" backable>
            </main-header>
        </template>

        <template #toolbar>
        </template>

        <template #body>
            <h2 class="text-left mb-3">{{ serverData.code }}</h2>

            <template v-if="!loading">
                <system-permission-group-item-tree-view
                        :items="items"
                        @click:bind="onBindClicked"
                        @click:unbind="onUnbindClicked"
                />
            </template>
            <template v-else>
                <div>
                    <v-progress-circular indeterminate size="48" :color="'primary'"
                    ></v-progress-circular>
                    <div class="mt-3">로드중...</div>
                </div>
            </template>
        </template>
    </main-layout>
</template>

<script>
    import MainHeader from "@/components/common/layout/MainHeader";
    import MainLayout from "@/components/common/layout/MainLayout";
    import {PATH} from "@/constants";
    import {PermissionTree} from "@/assets/plugins/mps-common/user/permission-manager";
    import SystemPermissionGroupItemTreeView from "@/views/permission/group-manage/SystemPermissionGroupItemTreeView";

    export default {
        name: "SystemPermissionGroupManageDetailByRentalcompany",
        components: {SystemPermissionGroupItemTreeView, MainLayout, MainHeader},
        props: {
            id: {
                type: Number,
                default: 0,
            },
        },
        data() {
            return {
                loading: false,
                permissionTree: undefined,
                serverData: {},
            };
        },
        computed: {
            items() {
                if (!this.permissionTree) return [];
                return this.permissionTree.items;
            },
        },
        created() {
            this.loadDetail();
            this.load();
        },
        methods: {
            async loadDetail() {
                this.serverData = await this.$request(PATH.SYSTEM_PERMISSION_GROUP.DETAIL)
                    .setObject({id: this.id})
                    .enqueue();
            },

            async load() {
                this.loading = true;
                await this.loadPermissions();
                const response = await this.$request(PATH.SYSTEM_PERMISSION_GROUP_ITEM.LIST)
                    .setObject({id: this.id})
                    .enqueue();

                this.permissionTree.nodes.forEach(node => {
                    if (!!response.data.find(item => node.id === item.id)) { // 그룹 아이템에 속한 노드라면
                        node.binded = true;
                    } else {
                        node.binded = false;
                    }
                });
                this.loading = false;
            },

            async loadPermissions() {
                const response = await this.$request(PATH.SYSTEM_PERMISSION.ALL_PERMISSION_BY_RENTALCOMPANY)
                    .post()
                    .enqueue();
                this.permissionTree = new PermissionTree(response.data);
            },

            /**
             * 권한 그룹 적용을 클릭하였습니다.
             */
            onBindClicked(node) {
                this.$confirm(this.serverData.code + " 권한 그룹에 " + node.canonicalName + " 권한을 추가하시겠습니까? !!상위의 노드들도 모두 권한 그룹에 추가됩니다.")
                    .then(() => this.requestBind({
                        permissionId: node.id,
                        permissionGroupId: this.id,
                    }));
            },

            async requestBind(requestBody) {
                await this.$requestWithOverlay(PATH.SYSTEM_PERMISSION_GROUP_ITEM.BIND_BY_RENTALCOMPANY)
                    .setObject(requestBody)
                    .enqueue();
                await this.load();
            },

            /**
             * 권한 그룹 적용해제를 클릭하였습니다.
             */
            onUnbindClicked(node) {
                this.$confirm(this.serverData.code + " 권한 그룹에서" + node.canonicalName + " 권한을 삭제하시겠습니까? 자식 노드의 권한들도 모두 그룹에서 삭제됩니다.")
                    .then(() => this.requestUnbind({
                        permissionId: node.id,
                        permissionGroupId: this.id,
                    }));
            },

            async requestUnbind(requestBody) {
                await this.$requestWithOverlay(PATH.SYSTEM_PERMISSION_GROUP_ITEM.UNBIND_BY_RENTALCOMPANY)
                    .setObject(requestBody)
                    .enqueue();
                await this.load();
            },
        },
    }
</script>

<style scoped>

</style>